import axios from "axios";
import { BASEURL } from "../constants/env-resolver";

const client = axios.create({
  baseURL: BASEURL,
  headers: { "content-type": "application/json" },
});

export default client;
